module.exports = __webpack_public_path__ + "static/media/volaby-original-dark.9446d1f1.svg";